
  document.addEventListener('bmm-product-update', (e) => {
    const visibleClass = 'td-price-detail--visible'
    const activePrices = document.querySelectorAll('.td-active-price-container')
    const salePrices = document.querySelectorAll('.td-sale-price-container')
    const saleTags = document.querySelectorAll('.td-sale-tag')
    if (activePrices.length && salePrices.length && saleTags.length) {
      const {normalPrice, price} = e.detail
      let npFloat
      let pFloat
      
      if (typeof normalPrice === 'string') {
        npFloat = parseFloat(normalPrice?.replace(/\$|,/gm,'') || 0)
      } else {
        npFloat = normalPrice || 0
      }
      if (typeof price === 'string') {
        pFloat = parseFloat(price?.replace(/\$|,/gm,'') || 0)
      } else {
        pFloat = price || 0
      }

      if (npFloat > pFloat) {
        activePrices.forEach((activePrice) => activePrice.innerText = activePrice.dataset.salePriceText.replace('{x}',price))
        salePrices.forEach((salePrice) => {
          salePrice.innerText = salePrice.dataset.priceText.replace('{x}', normalPrice)
          if (!salePrice.classList.contains(visibleClass)) {
            salePrice.classList.add(visibleClass)
          }
        })
        
        const normalPriceFloat = parseFloat(normalPrice.slice(1).replace(',',''))
        const priceFloat = parseFloat(price.slice(1).replace(',',''))
        const percentOff = Math.round((1-(priceFloat / normalPriceFloat)) * 100)
        saleTags.forEach((saleTag) => {
          if (saleTag.dataset.priceText) {
            saleTag.innerText = saleTag.dataset.priceText.replace('{x}',percentOff)
          }
        })

        // console.log("CHECKING", percentOff)
        if (percentOff <= 5 || percentOff % 5 !== 0) {
          saleTags.forEach((saleTag) => {
            if (saleTag.dataset.priceTextAlt) {
              saleTag.innerText = saleTag.dataset.priceTextAlt.replace('{x}',percentOff)
            }
          })

        }

        saleTags.forEach((saleTag) => {
          if (!saleTag.classList.contains(visibleClass)) {
            saleTag.classList.add(visibleClass)
          }  
        })

      } else {
        salePrices.forEach((salePrice) => {
          if (salePrice.classList.contains(visibleClass)) {
            salePrice.classList.remove(visibleClass)
          }
        })
        saleTags.forEach((saleTag) => {
          if (saleTag.classList.contains(visibleClass)) {
            saleTag.classList.remove(visibleClass)
          }
        })
        activePrices.forEach((activePrice) => activePrice.innerText = activePrice.dataset.noSaleText.replace('{x}',price))
      }
    }
  })

  document.addEventListener('td--ajax-add', (e) => {
    // alert('THIS NEEDS TO BE TESTED ON SHOPIFY PREVIEW')
    fetch(`/cart/add.js?sections=th-cart-drawer,cart-icon-bubble,cart-icon-bubble-mobile`, {
      body: JSON.stringify(e.detail),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      method: "post",
    }).then((response) => {
      return response.json();
    }).then((body) => {
       const sections = body.sections
       fetch('/cart.js').then(() => {
        document.dispatchEvent(new CustomEvent('td-cart-updated', {
          detail:  {
            sections: sections
          }
        }))
      })
    }).catch((err) => {
      console.error(err);
    });
  })

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-silo-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('td:gallery-changed', {detail: {slide: trigger}}));
      })
    })
  })
